import { createFileRoute } from '@tanstack/react-router';
import { PageStub } from '@/components/shared/PageStub';
import { AdminRoute } from '@/components/guards/AdminRoute';

export const Route = createFileRoute('/diagnostics/prime-path')({
  component: () => (
    <AdminRoute>
      <PageStub title="Prime Path Assessment" description="Business success score" />
    </AdminRoute>
  ),
});
